import api from 'Application/api/api';

const editStep = (signal, values) =>
	api.put('/step-templates', values, {
		signal,
	});

export default editStep;
